
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/publication",
      function () {
        return require("private-next-pages/node/publication.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/publication"])
      });
    }
  